var _colorVars;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var colors = {
  primaryDD: '#1d2390',
  primaryD: '#2d34b4',
  primary: '#3c44d7',
  primaryM: '#697edf',
  primaryL: '#a3afea',
  primaryLL: '#dce1f5',
  secondaryDD: '#cc0343',
  secondaryD: '#ff1f5e',
  secondary: '#ff5277',
  secondaryM: '#ff809b',
  secondaryL: '#ffb6c6',
  secondaryLL: '#ffe6ec',
  terciaryDD: '#222226',
  terciaryD: '#2e2e33',
  terciary: '#6d6d71',
  terciaryM: '#d5d5d6',
  terciaryL: '#eaeaea',
  terciaryLL: '#fff',
  accent1DD: '#024790',
  accent1D: '#106fd5',
  accent1: '#1785fb',
  accent1M: '#50a3fc',
  accent1L: '#98c9fd',
  accent1LL: '#e8f2fe',
  accent2DD: '#ab3500',
  accent2D: '#d75c25',
  accent2: '#ff7f46',
  accent2M: '#ff9f74',
  accent2L: '#ffc5ab',
  accent2LL: '#ffe9df',
  accent3DD: '#725322',
  accent3D: '#a97f41',
  accent3: '#cea05a',
  accent3M: '#dab884',
  accent3L: '#e8d3b3',
  accent3LL: '#f7eddf',
  chart1: '#527cff',
  chart2: '#b2d7ff',
  chart3: '#33cccc',
  chart4: '#15e4ab',
  chart5: '#ffd552',
  chart6: '#ff7f46',
  uiDDD: '#222226',
  uiDD: '#2e2e33',
  uiD: '#828e9f',
  ui: '#d1d8e2',
  uiM: '#e4e9ef',
  uiL: '#eff3fa',
  uiLL: '#f5f8fa',
  font: '#2e2e33',
  fontL: '#697782',
  fontLL: '#919da6',
  warnDD: '#826500',
  warnD: '#d2b32f',
  warn: '#ffde49',
  warnM: '#ffe77b',
  warnL: '#ffefa5',
  warnLL: '#fff7d5',
  positiveDD: '#14623f',
  positiveD: '#1da467',
  positive: '#29cb82',
  positiveM: '#64d8a2',
  positiveL: '#a2e7c5',
  positiveLL: '#e0f5e7',
  negativeDD: '#af0608',
  negativeD: '#d52427',
  negative: '#f94245',
  negativeM: '#fb7678',
  negativeL: '#fcb0b1',
  negativeLL: '#fee3e4'
};
export var colorVars = (_colorVars = {
  background: '#fff',
  borderColor: colors.uiM,
  borderColorL: colors.uiL,
  errorColor: colors.warn,
  errorFontColor: colors.uiDD,
  badgeColor: colors.accent3,
  tagFontColor: colors.accent1,
  tagBackgroundColor: colors.accent1LL,
  tagColor: colors.uiL,
  tagSelectedColor: colors.accent1,
  tagSelectedHoverColor: colors.accent1D,
  verifiedColor: colors.primary,
  ownMessageColor: colors.accent1,
  ratingStarColor: '#FFD700',
  ratingStarEmptyColor: colors.ui,
  ratingFeatureColor: colors.primary,
  ratingFeatureEmptyColor: colors.ui,
  buttonColor: colors.primary,
  buttonFontColor: '#fff',
  buttonHoverColor: colors.primaryD,
  buttonFocusActiveColor: colors.primaryDD,
  buttonFocusColor: 'rgba(60, 68, 215, 0.5)',
  buttonFocusShadowColor: 'rgba(60, 68, 215, 0.5)',
  secondaryButtonColor: colors.secondary,
  secondaryButtonFontColor: '#fff',
  secondaryButtonHoverColor: colors.secondaryD,
  secondaryButtonFocusActiveColor: colors.secondaryDD,
  secondaryButtonFocusColor: 'rgba(255, 82, 119, 0.5)',
  secondaryButtonFocusShadowColor: 'rgba(255, 82, 119, 0.5)',
  linkColor: colors.primary,
  followHoverColor: colors.primaryLL,
  followHoverFontColor: colors.primary,
  followedColor: colors.primary,
  followedFontColor: '#fff',
  footerColor: colors.uiDDD,
  defaultIconColor: colors.primary,
  headingTextColor: colors.terciaryD,
  componentFontColor: colors.terciaryD,
  bodyTextColor: colors.fontL,
  lightTextColor: colors.fontLL,
  mainColor: colors.primary,
  mainColorHover: colors.primaryD,
  rangeInputBarColor: colors.primary,
  selectedRadioGroupIconColor: colors.primary,
  selectedTabMenuBorderColor: colors.primary,
  secondaryColor: colors.secondary,
  preFormattedFieldColor: colors.secondary,
  terciaryColor: colors.terciaryDD,
  bodyBkgColor: colors.terciaryLL,
  resultBkg: colors.terciaryM,
  lightBkg: colors.terciaryM,
  mediumBkg: colors.terciary,
  darkBkg: colors.terciaryD,
  darkerBkg: colors.terciaryDD,
  navBkgColor: colors.terciaryLL,
  cookieMessageBkg: colors.primaryLL
}, _defineProperty(_colorVars, "borderColor", colors.ui), _defineProperty(_colorVars, "borderLighterColor", colors.uiM), _defineProperty(_colorVars, "placeholderColor", colors.terciaryM), _defineProperty(_colorVars, "errorColor", colors.negative), _defineProperty(_colorVars, "softErrorColor", colors.warn), _defineProperty(_colorVars, "globalErrorBkg", colors.primaryLL), _colorVars);